import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import {
  Card,
  CardActionArea,
  CardMedia,
  CircularProgress,
  Grid,
} from "@mui/material";

import { getReceiptImage } from "../../../services/ReceiptService";

const defaultImage = "/assets/images/image-upload-placeholder.png";

const useStyles = makeStyles({
  root: {},
});

const ReceiptDetail = ({ data }) => {
  const classes = useStyles();
  const [imageData, setImageData] = useState(defaultImage);
  const [loading, setLoading] = useState(false);

  const retrieveReceiptImage = useCallback(async (receiptId) => {
    try {
      setLoading(true);
      const res = await getReceiptImage(receiptId);
      setLoading(false);

      const image = res.length
        ? `data:image/jpeg;base64, ${res[0].FILE_STREAM}`
        : defaultImage; // IMAGE DATA

      setImageData(image);
    } catch (e) {
      console.error(e);
      toast.error("Unexpected error occurs while loading the image!");
    }
  }, []);

  useEffect(() => {
    if (!data) return;

    retrieveReceiptImage(data.RECEIPTS_ID);
  }, [data]);

  return (
    <Grid container alignItems="center" justifyContent="center">
      {loading ? (
        <Grid item>
          <CircularProgress size="4rem" />
        </Grid>
      ) : (
        <Grid item lg={3} md={3} sm={4} xs={6}>
          <Card>
            <CardActionArea>
              <CardMedia
                image={imageData}
                title="receipt thumbnail"
                sx={{ height: 240 }}
              />
            </CardActionArea>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default ReceiptDetail;
